import { render, staticRenderFns } from "./SettingComponentSportM8.vue?vue&type=template&id=024ca8a5&scoped=true&"
import script from "./SettingComponentSportM8.vue?vue&type=script&lang=js&"
export * from "./SettingComponentSportM8.vue?vue&type=script&lang=js&"
import style0 from "./SettingComponentSportM8.vue?vue&type=style&index=0&id=024ca8a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024ca8a5",
  null
  
)

export default component.exports